import { render } from "./ChordDict.vue?vue&type=template&id=b4b2b1c4&scoped=true"
import script from "./ChordDict.vue?vue&type=script&lang=js"
export * from "./ChordDict.vue?vue&type=script&lang=js"

import "./ChordDict.vue?vue&type=style&index=0&id=b4b2b1c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4b2b1c4"

export default script